import { vatLabel } from '@/lib/taxDisplay';

export const DocumentVatSelect = ({ value, onChange, testId }) => {
  const numeric = value == null || value === '' ? NaN : Number(String(value).trim().replace(',', '.'));
  const rates = [21, 6, 0];
  if (Number.isFinite(numeric) && !rates.includes(numeric)) rates.push(numeric);
  return <select className="field-input" style={{ padding: '3px 0px', fontSize: 11 }}
    value={Number.isFinite(numeric) ? String(numeric) : ''}
    onChange={event => onChange(Number(event.target.value))} data-testid={testId} aria-label="Btw-tarief">
    {!Number.isFinite(numeric) && <option value="" disabled>—</option>}
    {rates.map(rate => <option key={rate} value={rate}>{vatLabel(rate)}</option>)}
  </select>;
};